import { render } from "./GCompaniasView.vue?vue&type=template&id=500110bf"
import script from "./GCompaniasView.vue?vue&type=script&lang=js"
export * from "./GCompaniasView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__